export default {
  name: 'PcTableCell',
  data() {
    return {
      className: 'app__table__cell',
    };
  },
  props: {
    text: {
      type: String,
      default: '',
    },
    checkmark: {
      type: [String, Boolean],
      default: false,
    },
    align: {
      type: String,
      default: 'left',
    },
    type: {
      type: String,
      default: '',
    },
  },
  computed: {
    checkmarkClassName() {
      return `${this.className}__checkmark`;
    },
    alignClassName() {
      return this.align ? `${this.className}__align--${this.align}` : '';
    },
    typeClassName() {
      return this.type ? `${this.className}__${this.type}` : '';
    },
  },
};
